import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useCallContext } from '@gem/call/CallView/CallView.context';
import { AutoplayingLoopAudio } from '@gem/call/Removable/components/AutoplayingLoopAudio/AutoplayingLoopAudio';
import { useTranslation } from '@gem/modules/i18n';
import { Portal } from '@gem/ui-kit';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import busySound from 'ASSETS/sound/busy.mp3';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import callingSound from 'ASSETS/sound/ringback.mp3';

export const AudioSources: FC = observer(() => {
  const { t } = useTranslation();
  const context = useCallContext();

  if (!context.call) {
    return null;
  }

  return (
    <Portal>
      {context.call.isBusy || context.call.isNoAnswer ? (
        <AutoplayingLoopAudio
          src={busySound}
          permissionText={t('calls_hear_outgoing_call')}
          volume={0.5}
        />
      ) : null}

      {context.call.isCalling ? (
        <AutoplayingLoopAudio
          src={callingSound}
          permissionText={t('calls_hear_outgoing_call')}
          volume={0.5}
        />
      ) : null}
    </Portal>
  );
});
